<div class="row">
  <div class="col-xs-12 col-12 col-md-4 form-group">
    <input
      class="form-control"
      placeholder="Datepicker"
      bsDatepicker
      [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY',  returnFocusToInput: true }">
  </div>
  <div class="col-xs-12 col-12 col-md-4 form-group">
    <input type="text"
           placeholder="Daterangepicker"
           class="form-control"
           bsDaterangepicker
           [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY',  returnFocusToInput: true }">
  </div>
</div>
